<div class="d-flex align-items-center" role="navigation" aria-label="Appointment Booking Steps">
  <ul class="nav nav-pills nav-fill w-100" role="tablist">
    @if (partner?.is_customer_profiles_feature_enabled === 1 && partner?.customer_profiles?.length > 1) {
      <li
        class="nav-item"
        role="presentation"
        [ngClass]="{
          'active': viewMode === appointmentConstant.CUSTOMER_TYPE,
          'valid': partner?.customer_profiles?.length > 0
        }"
        [attr.aria-current]="viewMode === appointmentConstant.CUSTOMER_TYPE ? 'step' : undefined"
        role="tab"
      >
        <button
          type="button"
          class="nav-link btn"
          role="tab"
          id="customer-type-tab"
          [attr.aria-selected]="viewMode === appointmentConstant.CUSTOMER_TYPE"
          [attr.aria-controls]="'customer-type-panel'"
          [attr.tabindex]="viewMode === appointmentConstant.CUSTOMER_TYPE ? 0 : -1"
          #tab
          (click)="navigateToEvent.next(appointmentConstant.CUSTOMER_TYPE)"
          [attr.aria-selected]="viewMode === appointmentConstant.CUSTOMER_TYPE"
          [attr.aria-label]="'customer_type' | translate"
        >
          <span class="d-none d-sm-block">
            {{ 'customer_type' | translate }}
          </span>
          <span class="d-sm-none d-flex justify-content-center" aria-hidden="true">
            <fa-icon class="icon" icon="user" [title]="'customer_type' | translate" />
          </span>
        </button>
      </li>
    }

    @if(!isServicesTabDisabled) {
      <li
        class="nav-item"
        role="presentation"
        [ngClass]="{
          'active': viewMode === appointmentConstant.APPOINTMENT,
          'valid': appointmentState.services.length > 0
        }"
        [attr.aria-current]="viewMode === appointmentConstant.APPOINTMENT ? 'step' : undefined"
        role="tab"
      >
        <button
          type="button"
          [disabled]="isServicesTabDisabled || firstButtonDisabled"
          class="nav-link btn"
          role="tab"
          id="services-tab"
          aria-selected="true"
          aria-controls="services-panel"
          #tab
          (click)="navigateToEvent.next(appointmentConstant.APPOINTMENT)"
          [attr.aria-selected]="viewMode === appointmentConstant.APPOINTMENT"
          [attr.aria-disabled]="isServicesTabDisabled || firstButtonDisabled"
          [attr.aria-label]="widgetServiceLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
        >
          <span class="d-none d-sm-block">
            {{ widgetServiceLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
          </span>
          <span class="d-sm-none d-flex justify-content-center" aria-hidden="true">
            <fa-icon class="icon" icon="list" />
          </span>
        </button>
      </li>
    }

    @if (!hideResourceStep && workersAvailable?.length > 1 && appointmentState.services?.length) {
      <li
        class="nav-item"
        role="presentation"
        [ngClass]="{
          'active': viewMode === appointmentConstant.WORKER,
          'valid': appointmentState.worker !== null && viewMode !== appointmentConstant.APPOINTMENT
        }"
        [attr.aria-current]="viewMode === appointmentConstant.WORKER ? 'step' : undefined"
        role="tab"
      >
        <button
          type="button"
          class="nav-link btn"
          role="tab"
          id="worker-tab"
          [disabled]="secondButtonDisabled"
          #tab
          (click)="navigateToEvent.next(appointmentConstant.WORKER)"
          [attr.aria-selected]="viewMode === appointmentConstant.WORKER"
          [attr.aria-disabled]="secondButtonDisabled"
          [attr.aria-label]="widgetResourceLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
        >
          <span class="d-none d-sm-block">
            {{ widgetResourceLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
          </span>
          <span class="d-sm-none d-flex justify-content-center" aria-hidden="true">
            <fa-icon class="icon" icon="user" />
          </span>
        </button>
      </li>
    }

    @if (!hideMeetingTypesStep && appointmentState?.services?.length && appointmentState?.worker && appointmentState?.has_meeting_types_restrictions) {
      <li
        class="nav-item"
        role="presentation"
        [ngClass]="{ 
          'active': viewMode === appointmentConstant.MEETING_PROVIDERS, 
          'valid': appointmentState.meeting_type_id && viewMode !== appointmentConstant.MEETING_PROVIDERS 
        }"
        [attr.aria-current]="viewMode === appointmentConstant.MEETING_PROVIDERS ? 'step' : undefined"
        role="tab"
      >
        <button
          type="button"
          class="nav-link btn"
          #tab
          role="tab"
          id="meeting-type-tab"
          [disabled]="!appointmentState.worker"
          (click)="navigateToEvent.next(appointmentConstant.MEETING_PROVIDERS)"
          [attr.aria-selected]="viewMode === appointmentConstant.MEETING_PROVIDERS"
          [attr.aria-disabled]="!appointmentState.worker"
          [attr.aria-label]="widgetMeetingTypesLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
        >
          <span class="d-none d-sm-block">
            {{ widgetMeetingTypesLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
          </span>
          <span class="d-sm-none d-flex justify-content-center" aria-hidden="true">
            <fa-icon class="icon" icon="handshake" />
          </span>
        </button>
      </li>
    }

    <li
      class="nav-item"
      role="presentation"
      [ngClass]="{
        'active': viewMode === appointmentConstant.DATE,
        'valid': appointmentState.date !== null && cart?.length > 0 && viewMode !== appointmentConstant.DATE
      }"
      [attr.aria-current]="viewMode === appointmentConstant.DATE ? 'step' : undefined"
      role="tab"
    >
      <button
        type="button"
        class="nav-link btn"
        #tab
        role="tab"
        id="date-tab"
        [disabled]="thirdButtonDisabled"
        (click)="navigateToEvent.next(appointmentConstant.DATE)"
        [attr.aria-selected]="viewMode === appointmentConstant.DATE"
        [attr.aria-disabled]="thirdButtonDisabled"
        [attr.aria-label]="widgetDateLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
      >
        <span class="d-none d-sm-block">
          {{ widgetDateLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
        </span>
        <span class="d-sm-none d-flex justify-content-center" aria-hidden="true">
          <fa-icon class="icon" icon="calendar" />
        </span>
      </button>
    </li>

    <li
      class="nav-item"
      role="presentation"
      [ngClass]="{
        'active': viewMode === appointmentConstant.PERSONAL_INFO,
        'valid': formService.personalFormValid && appointmentState.date !== null && cart?.length > 0 && viewMode === appointmentConstant.SUMMARY
      }"
      [attr.aria-current]="viewMode === appointmentConstant.PERSONAL_INFO ? 'step' : undefined"
      role="tab"
    >
      <button
        type="button"
        class="nav-link btn"
        #tab
        role="tab"
        id="personal-info-tab"
        [disabled]="forthButtonDisabled"
        (click)="cart?.length ? navigateToEvent.next(appointmentConstant.PERSONAL_INFO) : ignore()"
        [attr.aria-selected]="viewMode === appointmentConstant.PERSONAL_INFO"
        [attr.aria-disabled]="forthButtonDisabled"
        [attr.aria-label]="partner?.split_personal_form_and_summary_in_widget === 1 ? (widgetNavigationPersonalDetailsLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) : (widgetPersonalLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)"
      >
        <span class="d-none d-sm-block">
          @if (partner?.split_personal_form_and_summary_in_widget === 1) {
            {{ widgetNavigationPersonalDetailsLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
          } @else {
            {{ widgetPersonalLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
          }
        </span>
        <span class="d-sm-none d-flex justify-content-center" aria-hidden="true">
          <fa-icon class="icon" icon="check" />
        </span>
      </button>
    </li>

    @if (partner?.split_personal_form_and_summary_in_widget === 1) {
      <li
        class="nav-item"
        role="presentation"
        [ngClass]="{
          'active': viewMode === appointmentConstant.SUMMARY
        }"
        [attr.aria-current]="viewMode === appointmentConstant.SUMMARY ? 'step' : undefined"
        role="tab"
      >
        <button
          type="button"
          class="nav-link btn"
          #tab
          role="tab"
          id="summary-tab"
          [disabled]="fifthButtonDisabled"
          (click)="summaryTabClick()"
          [attr.aria-selected]="viewMode === appointmentConstant.SUMMARY"
          [attr.aria-disabled]="fifthButtonDisabled"
          [attr.aria-label]="widgetPersonalLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
        >
          <span class="d-none d-sm-block">
            {{ widgetPersonalLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
          </span>
          <span class="d-sm-none d-flex justify-content-center" aria-hidden="true">
            <fa-icon class="icon" icon="check" />
          </span>
        </button>
      </li>
    }
  </ul>

  @if (langSwitcher && supportedWidgetLanguages?.length > 1) {
    <div role="navigation" aria-label="Language Selection">
      <div ngbDropdown class="d-inline-block">
        <button 
          class="nav-link lang-dropdown" 
          id="nav-lang-dropdown" 
          ngbDropdownToggle 
          aria-label="Select language"
          [attr.aria-expanded]="false"
          [attr.aria-haspopup]="true"
        >
          <span>
            @for (language of widgetConstants.LANGUAGES; track language.value) {
              @if (lang === language.locale) {
                <img 
                  width="20" 
                  height="20" 
                  loading="lazy"
                  [alt]="language.text + ' flag'"
                  [title]="language.text" 
                  [src]="deployUrl + language.flagIcon" 
                />
              }
            }
          </span>
        </button>

        <div 
          class="lang-dropdown-menu" 
          ngbDropdownMenu 
          role="listbox"
          aria-labelledby="nav-lang-dropdown"
        >
          @for (language of widgetConstants.LANGUAGES; track language.value) {
            @if (lang !== language.locale && supportedWidgetLanguages && supportedWidgetLanguages.indexOf(language.value) > -1) {
              <button 
                ngbDropdownItem 
                class="lang-dropdown-menu-item" 
                role="option"
                [attr.aria-selected]="lang === language.locale"
                (click)="switchLanguage(language.locale)"
              >
                <span class="d-flex justify-content-center">
                  <img 
                    width="20" 
                    height="20" 
                    alt="{{ language.text | titlecase }}" 
                    title="{{ language.text | titlecase }}" 
                    src="{{ deployUrl + language.flagIcon }}" 
                  />
                </span>
              </button>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
